
enum CalendarSettingsPriceRecommendationIndicatorType {
	AMOUNT = 'AMOUNT',
	PERCENTAGE='PERCENTAGE'
}

export default CalendarSettingsPriceRecommendationIndicatorType